import dayjs from 'dayjs'
import { companyAdvanceConfig, contractNoAuthConfig } from '../../../constant/advanceConfig.js'
import { APPLY_TYPES_MAIN } from '../../../constant/contractConstant.js'
import store from '@/store/index';
const tenantCode = store.getters.currentTenant.tenantCode;

const config = {
    searchList: {
        searchTxt: [
            {
                name: 'MIP流程编码',
                value: 'flowId',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '仓库人员编码',
                value: 'warehouseWorkerNo',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '身份证号',
                value: 'idCardNo',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '仓库人员名称',
                value: 'workerName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '薪资未发原因',
                value: 'noPaySalaryReasonList',
                type: 'select',
                options: [],
                multiple: true,
                optionNum: 'NO_PAY_SALARY_REASON',
                unfold: true,
                span: 3
            },
            {
                name: '薪资月份',
                value: 'month',
                type: 'time',
                timeType: 'month',
                format: 'yyyy-MM',
                placeholder: '薪资月份',
                unfold: true,
                span: 3
            },
            {
                name: '审批状态',
                value: 'auditStatusList',
                type: 'select',
                options: [],
                multiple: true,
                optionNum: 'SALARY_REASON_AUDIT_STATUS',
                unfold: true,
                span: 3
            },
            {
                name: '工资确认',
                value: 'confirmStatusList',
                unfold: true,
                type: 'select',
                multiple: true,
                optionNum: 'SALARY_CONFIRM_STATUS',
                options: [],
                span: 3
            },
            {
                ...contractNoAuthConfig,
                name: '合同',
                extraParams: { applyType: APPLY_TYPES_MAIN },
                unfold: false,
                span: 3
            },
            {
                name: '供应商',
                value: 'supplierName',
                advanceLabel: '供应商弹出框',
                type: 'advance',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierName', value: '供应商名称' },
                ],
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierName', value: '供应商名称' },
                    { prop: 'supplierTypeName', value: '供应商类型' },
                ],
                cbParams: [
                    'supplierCode',
                    'supplierName',
                ],
                prefix: 'api-srm-web',
                advanceUrl: '/supplier/getSupplierInfosByNameAndCode',
                extraParams: { tenantCode },
                notFetchOnShow: true,
                queryConditionRequired: true,
                searchRequired: true,
                span: 4,
                unfold: true,
            },
            {
                ...companyAdvanceConfig,
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' }
                ],
                unfold: false,
                span: 3
            },
            {
                name: '经营中心',
                value: 'businessName',
                type: 'input',
                unfold: false,
                span: 3,
            },
            {
                name: '物理仓',
                value: 'physicalWarehouseName',
                type: 'advance',
                advanceLabel: '物理仓',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'whName', value: '物理仓名称' },
                    { prop: 'whCode', value: '物理仓编码' },
                ],
                tableConfig: [
                    { prop: 'whCode', value: '物理仓编码' },
                    { prop: 'whName', value: '名称' },
                    { prop: 'whAddress', value: '地址' },
                    { prop: 'whSquare', value: '仓库面积' },
                ],
                advanceUrl: '/supplier/supplierPhysicsWarehouse/pageList',
                prefix: 'api-srm-web',
                method: 'post',
                cbParams: [
                    'whCode#physicalWarehouseCode',
                    'whName#physicalWarehouseName',
                    // 'whNameArray#physicalWarehouseNameArray',
                ],
                // advanceCascade: 'supplierCode',
                span: 3,
                unfold: true,
                // advanceRequire: [{ prop: 'supplierCode', message: '请先选择供应商名称!' }]
            },
            {
                name: '逻辑仓',
                value: 'logicalWarehouseName',
                type: 'advance',
                advanceLabel: '逻辑仓',
                advanceConfig: [
                    // { prop: 'ALL', value: '全部' },
                    { prop: 'cdwhName', value: '逻辑仓名称' },
                    { prop: 'whCode', value: '逻辑仓编码' },
                ],
                tableConfig: [
                    { prop: 'whCode', value: '逻辑仓编码' },
                    { prop: 'cdwhName', value: '逻辑仓名称' },
                ],
                advanceUrl: '/public/api/searchCdWarehouse',
                prefix: '/api-srm',
                method: 'get',
                cbParams: ['cdwhName#logicalWarehouseName', 'whCode#logicalWarehouseCode'],
                // advanceCascade: 'supplierCode',
                span: 3,
                unfold: false,
                // advanceRequire: [{ prop: 'supplierCode', message: '请先选择供应商名称!' }]
            },
            {
                name: '主工作逻辑仓',
                value: 'mainLogicalWarehouseName',
                type: 'advance',
                advanceLabel: '主工作逻辑仓',
                advanceConfig: [
                    { prop: 'cdwhName', value: '逻辑仓名称' },
                    { prop: 'whCode', value: '逻辑仓编码' }
                ],
                tableConfig: [
                    { prop: 'whCode', value: '逻辑仓编码' },
                    { prop: 'cdwhName', value: '名称' },
                ],
                advanceUrl: '/public/api/searchCdWarehouse',
                prefix: '/api-srm',
                method: 'get',
                cbParams: ['cdwhName#mainLogicalWarehouseName', 'whCode#mainLogicalWarehouseCode'],
                span: 3,
                unfold: true,
            },
            {
                name: '发薪日期配置',
                value: 'salaryPaydayCodeList',
                type: 'select',
                multiple: true,
                optionNum: 'SALARY_PAYDAY',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '创建时间',
                value: 'createTimeArr',
                type: 'time',
                startPlaceholder: '开始时间',
                endPlaceholder: '结束时间',
                // timeNum: 30,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(6, 'd').toDate();
                                const end = dayjs().endOf('day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(30, 'd').toDate();
                                const end = dayjs().endOf('day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近两个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(60, 'd').toDate();
                                const end = dayjs().endOf('day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(90, 'd').toDate();
                                const end = dayjs().endOf('day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                    ]
                },
                unfold: true,
                span: 5,
            },
            {
                "name": "客户",
                "value": "customerName",
                "type": "advance",
                "unfold": false,
                "advanceConfig": [
                    { "prop": "ebcuNameCn", "value": "客户名称" },
                    { "prop": "pmCode", "value": "客户编码" }
                ],
                "tableConfig": [
                    { "prop": "ebcuNameCn", "value": "客户名称" },
                    { "prop": "pmCode", "value": "客户编码" }
                ],
                "advanceUrl": "/ebCustomer/searchByEbCustomer",
                "cbParams": ["pmCode#customerCode", "ebcuNameCn#customerName"],
                "span": 3,
                "multiple": true,
                "multipleTableColumn": { prop: 'ebcuNameCn', value: '客户名称' },
                "multipleDelConfirm": true,
                "max": 15,
            },
            {
                'name': '业务场景',
                'value': 'businessSceneList',
                'type': 'select',
                'multiple': true,
                'optionNum': 'BUSINESS_SCENE',
                'options': [],
                'span': 3,
                'unfold': false,
            },
            // {
            //     name: '寻源名称',
            //     value: 'supplierSourcingName',
            //     type: 'input',
            //     unfold: true,
            //     span: 3,
            // },
            // {
            //     name: '任务程度',
            //     value: 'taskLevelList',
            //     unfold: true,
            //     type: 'select',
            //     multiple: true,
            //     optionNum: 'SUPPLIER_SOURCING_TASK_LEVEL',
            //     options: [],
            //     span: 3
            // },
            // {
            //     ...companyAdvanceConfig,
            //     span: 4
            // },
            // {
            //     name: '创建时间',
            //     value: 'createTimeArr',
            //     type: 'time',
            //     startPlaceholder: '创建开始时间',
            //     endPlaceholder: '创建结束时间',
            //     timeNum: 90,
            //     pickerOptions: {
            //         shortcuts: [
            //             {
            //                 text: '最近一个月',
            //                 onClick(picker) {
            //                     const start = dayjs().startOf('day').subtract(30, 'd').toDate();
            //                     const end = dayjs().endOf('day').toDate();
            //                     picker.$emit('pick', [start, end]);
            //                 }
            //             },
            //             {
            //                 text: '最近三个月',
            //                 onClick(picker) {
            //                     const start = dayjs().startOf('day').subtract(90, 'd').toDate();
            //                     const end = dayjs().endOf('day').toDate();
            //                     picker.$emit('pick', [start, end]);
            //                 }
            //             },
            //             {
            //                 text: '最近六个月',
            //                 onClick(picker) {
            //                     const start = dayjs().startOf('day').subtract(180, 'd').toDate();
            //                     const end = dayjs().endOf('day').toDate();
            //                     picker.$emit('pick', [start, end]);
            //                 }
            //             },
            //         ]
            //     },
            //     unfold: true,
            //     span: 5,
            // },
        ],
        unfoldState: false,
        advancedBtn: true,
        resetBtn: true,
    },
    searchTotalTitle: [],
    table: {
        // 'tableCut': true,
        // 'clickModify': true,
        leftOperation: true,
        selectBtn: true,
        height: 'calc(100vh - 206px)',
        leftWidth: 220,
        columns: [
            {
                label: '姓名',
                prop: 'workerName',
                width: '100px',
            },
            {
                label: '手机号码',
                prop: 'workerPhone_',
                width: '120px',
            },
            {
                label: '身份证号',
                prop: 'idCardNo_',
                width: '160px',
            },
            {
                label: '客户名称',
                prop: 'customerName',
                info: '安心签-员工管理-客户名称',
                width: '150px',
            },
            {
                label: '业务场景',
                prop: '_businessScene',
                // type: 'select',
                // options: [],
                info: '安心签-员工管理-业务场景名称',
                // optionNum: 'BUSINESS_SCENE',
                width: '130px',
            },
            {
                label: '主工作逻辑仓',
                prop: 'mainLogicalWarehouseName',
                width: '230px',
            },
            {
                label: 'MIP流程编码',
                prop: 'flowId',
                width: '160px',
            },
            {
                label: '工资确认',
                prop: 'confirmStatus',
                type: 'select',
                options: [],
                optionNum: 'SALARY_CONFIRM_STATUS',
                width: '160px',
            },
            {
                label: '薪资月份',
                prop: 'month_',
                width: '100px',
            },
            {
                label: '推送工资确认ID',
                prop: 'confirmCode',
                width: '170px',
            },
            {
                label: '仓库人员编码',
                prop: 'warehouseWorkerNo',
                width: '150px',
            },
            {
                label: '单据编码(合同)',
                prop: 'contractCode',
                width: '150px',
            },
            {
                label: '法务合同号(合同)',
                prop: 'legalContractCode',
                width: '150px',
            },
            {
                label: '物理仓',
                prop: 'physicalWarehouseName',
                width: '150px',
            },
            {
                label: '逻辑仓',
                prop: 'logicalWarehouseName',
                width: '150px',
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: '160px',
            },
            {
                label: '合同名称',
                prop: 'contractName',
                width: '160px',
            },
            {
                label: '经营中心',
                prop: 'businessName',
                width: '140px',
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: '140px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '130px',
            },
            {
                label: '供应商名称',
                prop: 'supplierName',
                width: '160px',
            },
            {
                label: '审批人',
                prop: 'approval',
                width: '160px',
            },
            {
                label: '发薪日期配置',
                prop: 'salaryPaydayCode',
                type: 'select',
                options: [],
                optionNum: 'SALARY_PAYDAY',
                width: '100px',
            },
            {
                label: '发薪日期',
                prop: 'actualSalaryPayday',
                width: '100px',
            },
            {
                label: '短信内容',
                prop: 'smsContent',
                width: '200px',
            },
            {
                label: '原因反馈',
                prop: 'suggestion',
                width: '160px',
            },
            {
                label: '发送待办次数',
                prop: 'todoCount',
                width: '120px',
            },
            {
                label: '待办人(经营中心)',
                prop: 'businessTodoUserName',
                width: '170px',
            },
            {
                label: '待办人(分公司)',
                prop: 'companyTodoUserName',
                width: '150px',
            },
            {
                label: '审批状态',
                prop: 'auditStatus',
                type: 'select',
                options: [],
                optionNum: 'SALARY_REASON_AUDIT_STATUS',
                width: '160px',
            },
            {
                label: '薪资未发原因',
                prop: '_noPaySalaryReason',
                width: '160px',
            },
            {
                label: '备注说明',
                prop: 'salaryReasonRemark',
                width: '100px',
            },
            {
                label: '附件',
                prop: 'fileName',
                width: '200px',
                type: 'button'
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '100px',
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: '160px',
            },
        ],
        action: [
            // {
            //     type: 'text',
            //     label: '重推',
            //     size: 'mini',
            //     event: 'repush',
            // },
            {
                type: 'text',
                label: '详情页',
                size: 'mini',
                event: 'detail',
            },
            {
                type: 'text',
                label: '操作记录',
                size: 'mini',
                event: 'record',
            },
            {
                type: 'text',
                label: '流程记录',
                size: 'mini',
                event: 'progress',
            },
        ],
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 100],
    },
}
export default config
